import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "./ui/button";

export function Pagination({ onNext, onPrevious, page, totalPages }) {
  return (
    <div className="glass-panel flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-muted-foreground">
        Page {page} of {totalPages}
      </p>
      <div className="flex items-center gap-3">
        <Button disabled={page <= 1} onClick={onPrevious} type="button" variant="secondary">
          <ChevronLeft className="h-4 w-4" />
          Previous
        </Button>
        <Button
          disabled={page >= totalPages}
          onClick={onNext}
          type="button"
          variant="secondary"
        >
          Next
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
